module.exports = __webpack_public_path__ + "img/animal_hospital_search.f878b151.png";